// extracted by mini-css-extract-plugin
export default {"body":"style_body__1gQ+X","wrap":"style_wrap__4utHb"};